import { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { extrairMensagemErro } from '../../components/common/ErroCarregamento';

export default function Login() {
  const { user, loading, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState('');
  const [entrando, setEntrando] = useState(false);

  if (!loading && user) return <Navigate to="/dashboard" replace />;

  const enviar = async (e) => {
    e.preventDefault();
    setErro('');
    setEntrando(true);
    try {
      await login(email, senha);
      navigate('/dashboard', { replace: true });
    } catch (err) {
      setErro(extrairMensagemErro(err, 'Não foi possível entrar. Verifique e-mail e senha.'));
    } finally {
      setEntrando(false);
    }
  };

  return (
    <div
      className="d-flex align-items-center justify-content-center p-3"
      style={{ minHeight: '100vh', background: 'linear-gradient(160deg, #111a2b 0%, #1b2942 60%, #26354f 100%)' }}
    >
      <div className="card-soft" style={{ width: '100%', maxWidth: 400 }}>
        <div className="card-soft__body">
          <div className="text-center mb-4">
            <i className="bi bi-broadcast-pin" style={{ fontSize: 34, color: 'var(--wh-accent)' }} />
            <h1 style={{ fontSize: 20, marginTop: 8, marginBottom: 2 }}>Webhook Datafit</h1>
            <div style={{ fontSize: 13, color: 'var(--wh-ink-2)' }}>Receptor genérico de webhooks</div>
          </div>

          <form onSubmit={enviar}>
            <div className="mb-3">
              <label className="wh-label" htmlFor="email">
                E-mail
              </label>
              <input
                id="email"
                type="email"
                className="wh-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="username"
                required
                autoFocus
              />
            </div>
            <div className="mb-3">
              <label className="wh-label" htmlFor="senha">
                Senha
              </label>
              <input
                id="senha"
                type="password"
                className="wh-input"
                value={senha}
                onChange={(e) => setSenha(e.target.value)}
                autoComplete="current-password"
                required
              />
            </div>

            {erro && (
              <div className="alert alert-danger py-2 px-3" style={{ fontSize: 13 }}>
                {erro}
              </div>
            )}

            <button type="submit" className="wh-btn wh-btn-primary w-100 justify-content-center" disabled={entrando}>
              {entrando ? 'Entrando...' : 'Entrar'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
